export const CHART_COLORS = {
  GOOD: '#10b981',
  GOOD_ALT: '#16a34a',
  AVG: '#f59e0b',
  AVG_ALT: '#ea580c',
  POOR: '#ef4444',
  POOR_ALT: '#dc2626',
};

export const DEFAULT_BAR_COLORS = [
  CHART_COLORS.GOOD,
  CHART_COLORS.AVG,
  CHART_COLORS.POOR,
];

export const DEFAULT_LEGEND_CONFIG = {
  position: 'top',
  offsetY: 20,
  useSeriesColors: true,
  markers: {
    width: 12,
    height: 12,
    strokeWidth: 0,
    opacity: 0.6,
    radius: 3,
  },
  fontSize: '13px',
  fontWeight: 600,
};
